export async function useAgeGroups() {
  const allAgeGroups = useState<AgeGroup[]>('allAgeGroups', () => [])

  if (!allAgeGroups.value || !allAgeGroups.value.length) {
    const { data: ageGroups } = await fetchAgeGroups()
    if (ageGroups.value) {
      allAgeGroups.value = ageGroups.value
    }
  }

  return { ageGroups: computed(() => allAgeGroups.value) }
}
